import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "./i18n";
import { capturarRef } from "./lib/referral";

// Antes del primer render: el ?ref= viene en la URL de llegada y un redirect
// temprano (p.ej. / -> /dashboard con sesion) lo perderia si se esperara a un
// useEffect.
capturarRef();

// Components
import AppRoutes from "./AppRoutes";
import AuthenticatedChatbot from "./components/AuthenticatedChatbot";

// Context
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <AuthenticatedChatbot />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
